import { PopupHint, FormRow, TextInput, Button, Col } from '@op/opds.opux';
import { IconAdd, IconSubtract } from '@op/opds.opux-icons/action';
import '../App.css';

const InputRow = ({ inputTestId, btnTestDecId, btnTestAddId, tooltipMsg, labelMsg, btnAddValue, btnDecValue, value, setInputValue, select, disableDecBtn, disableAddBtn, btnDecName, btnAddName, btnDecId, btnAddId, inputRowId, inputRef }) => {

    return (
        <Col xs={12} md={6} className="formCol">
            <FormRow
                hint={<PopupHint className="popup-hint">{tooltipMsg}</PopupHint>}
                label={labelMsg}
                labelFor={labelMsg}
            >
                <div id={inputRowId} className="input-row-flex">
                    <TextInput
                        value={value}
                        type="text"
                        onChange={setInputValue}
                        unit="€"
                        id={labelMsg}
                        onFocus={select}
                        ref={inputRef}
                        data-testid={inputTestId}
                    />
                    <Button
                        id={btnDecId}
                        icon={IconSubtract}
                        iconLabel={btnDecName}
                        minified
                        primary
                        onClick={btnDecValue}
                        type="button"
                        disabled={disableDecBtn}
                        data-testid={btnTestDecId}
                        className="btnDec-visually-move-left"
                    />
                    <Button
                        id={btnAddId}
                        icon={IconAdd}
                        iconLabel={btnAddName}
                        minified
                        primary
                        onClick={btnAddValue}
                        type="button"
                        disabled={disableAddBtn}
                        data-testid={btnTestAddId}
                    />
                </div>
            </FormRow>
        </Col>
    )
}

export default InputRow;